import { Drawer, List, Stack, useTheme } from '@mui/material'
import { ListItem, SIPPDescription } from '../../subComponent'
import { LearnIcon, MapIcon } from '../../../icons'
import { useStyles } from '../../../../theme'
import { ElementRef } from 'react'

interface SidebarDrawerProps {
  open: boolean
  onClose: () => void
  selectedIndex: number
  onListItemClick: (index: number) => void
  containerRef: ElementRef<any>
}

export const SidebarDrawer = ({
  open,
  onClose,
  selectedIndex,
  onListItemClick,
  containerRef,
}: SidebarDrawerProps) => {
  const theme = useTheme()
  const styles = useStyles()
  const drawerWidth = 272

  return (
    <Drawer
      open={open}
      onClose={onClose}
      PaperProps={{ style: { position: 'absolute' } }}
      ModalProps={{container:(containerRef as any).current}}
      anchor="left"
      variant="persistent"
      sx={{
        display: 'flex',
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
         // marginTop: 8.5,
         // height: 'calc(100% - 68px)',
        },
      }}
    >
      <Stack
        sx={{
          height: '100%',
          justifyContent: 'space-between',
          px: 1.5,
          pb: 2,
          gap: 6,
          ...styles.scrollbar,

        }}
      >
        <List sx={{ borderBottom: `1px solid ${theme.palette.grey[200]}` }}>
          <ListItem
            index={0}
            selectedIndex={selectedIndex}
            onClick={onListItemClick}
            icon={<MapIcon sx={{ color: 'transparent' }} />}
            label="Water quality map"
          />
          <ListItem
            index={1}
            selectedIndex={selectedIndex}
            onClick={onListItemClick}
            icon={<LearnIcon sx={{ color: 'transparent' }} />}
            label="Learn"
          />
        </List>
        <SIPPDescription />
      </Stack>
    </Drawer>
  )
}